import React from 'react';
import ReactFlow from 'react-flow-renderer';
import '../FLowChart/FLowChart.css';

// JSON data
const data = {
  ROE: {
    value: '33.65%',
    'Net Margin': {
      value: '42%',
      'Operating Margin': '$4.7049',
      'Tax Burden': '0.8466',
      'Interest Burden': '1.0650',
    },
    'Assets Turnover': {
      value: '0.50',
      Revenue: '$95.18',
      'Average Total Assets': '$188.9B',
    },
    'Equity Multiplier': {
      value: '1.056',
      'Average Total Assets': '$188.9B',
      'Average Total Stockholder Equity': '$121.0B',
    },
  },
};

const FlowChart = () => {
  // Create nodes from the provided data
  const nodes = [
    { id: 'ROE', data: { label: `ROE%: ${data.ROE.value}` }, position: { x: 250, y: 50 } },
    { id: 'NetMargin', data: { label: `Net Margin: ${data.ROE['Net Margin'].value}` }, position: { x: 250, y: 150 } },
    { id: 'OperatingMargin', data: { label: `Operating Margin: ${data.ROE['Net Margin']['Operating Margin']}` }, position: { x: 50, y: 250 } },
    { id: 'TaxBurden', data: { label: `Tax Burden: ${data.ROE['Net Margin']['Tax Burden']}` }, position: { x: 250, y: 250 } },
    { id: 'InterestBurden', data: { label: `Interest Burden: ${data.ROE['Net Margin']['Interest Burden']}` }, position: { x: 450, y: 250 } },

    { id: 'AssetsTurnover', data: { label: `Assets Turnover: ${data.ROE['Assets Turnover'].value}` }, position: { x: 250, y: 350 } },
    { id: 'Revenue', data: { label: `Revenue: ${data.ROE['Assets Turnover'].Revenue}` }, position: { x: 50, y: 450 } },
    { id: 'AverageTotalAssets1', data: { label: `Average Total Assets: ${data.ROE['Assets Turnover']['Average Total Assets']}` }, position: { x: 250, y: 450 } },

    { id: 'EquityMultiplier', data: { label: `Equity Multiplier: ${data.ROE['Equity Multiplier'].value}` }, position: { x: 250, y: 550 } },
    { id: 'AverageTotalAssets2', data: { label: `Average Total Assets: ${data.ROE['Equity Multiplier']['Average Total Assets']}` }, position: { x: 50, y: 650 } },
    { id: 'AverageTotalStockholderEquity', data: { label: `Average Total Stockholder Equity: ${data.ROE['Equity Multiplier']['Average Total Stockholder Equity']}` }, position: { x: 450, y: 650 } },
  ];

  // Define the edges with different types
  const edges = [
    { id: 'e1', source: 'ROE', target: 'NetMargin', type: 'step' },
    { id: 'e2', source: 'NetMargin', target: 'OperatingMargin', type: 'step' },
    { id: 'e3', source: 'NetMargin', target: 'TaxBurden', type: 'step' },
    { id: 'e4', source: 'NetMargin', target: 'InterestBurden', type: 'step' },
    { id: 'e5', source: 'ROE', target: 'AssetsTurnover', type: 'step' },
    { id: 'e6', source: 'AssetsTurnover', target: 'Revenue', type: 'step' },
    { id: 'e7', source: 'AssetsTurnover', target: 'AverageTotalAssets1', type: 'step' },
    { id: 'e8', source: 'ROE', target: 'EquityMultiplier', type: 'straight' },
    { id: 'e9', source: 'EquityMultiplier', target: 'AverageTotalAssets2', type: 'step' },
    { id: 'e10', source: 'EquityMultiplier', target: 'AverageTotalStockholderEquity', type: 'step' },
  ];

  return (
    <div className='flow-container'>
      <h3>Financial Performance Breakdown: ROE and Its Key Drivers</h3>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        style={{
          // background: '#f0f0f0',
          borderRadius: '8px',
          padding: '20px',
          height:'450px'
        }}
      />
    </div>
  );
};

export default FlowChart;
